<template>
  <div>
    <component v-bind:is="displayedComponent"></component>
    <div v-show="readyWaiting">
      <p class="headline text-xs-center">You're good to go!</p>
      <p>Connected as team name <span class="font-weight-bold">{{team.teamName}}</span>. Please wait for the host to see what's next.</p>
      <v-card>
        <v-container
          grid-list-sm
          fluid
        >
          <v-layout
            row
            wrap
          >
            <v-flex
              v-for="n in 9"
              :key="n"
              xs4
              d-flex
            >
              <v-card
                flat
                tile
                class="d-flex"
              >
                <v-img
                  :src="`https://picsum.photos/500/300?image=${n * 5 + 10}`"
                  :lazy-src="`https://picsum.photos/10/6?image=${n * 5 + 10}`"
                  aspect-ratio="1"
                  class="grey lighten-2"
                >
                  <v-layout
                    slot="placeholder"
                    fill-height
                    align-center
                    justify-center
                    ma-0
                  >
                    <v-progress-circular
                      indeterminate
                      color="grey lighten-5"
                    ></v-progress-circular>
                  </v-layout>
                </v-img>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
      <p class="ma-2">Having problems? Clear out team data and disconnect.</p>
      <v-btn
        color="primary"
        dark
        small
        flat
        @click="showDisconnect = true"
      >Disconnect</v-btn>
      <div v-show="showDisconnect">
        <v-btn
          color="grey"
          dark
          @click="showDisconnect = false"
        >Cancel</v-btn>
        <v-btn
          color="red"
          dark
          @click="disconnectTeam"
        >Disconnect (This is game over!)</v-btn>
      </div>

    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import GameModel from "../../api/game-model";
import CategoryResults from "./CategoryResults";
import FinalResults from "./FinalResults";
import IntroduceCategory from "./IntroduceCategory";
import Question from "./Question";

export default {
  name: "ConnectedClient",
  data() {
    return {
      gameStates: GameModel.GameClientState,
      displayedComponent: "",
      showDisconnect: false
    };
  },
  methods: {
    ...mapActions("client", ["disconnectTeam"])
  },
  computed: {
    ...mapState("client", {
      gameClientState: state => state.game.gameClientState
    }),
    ...mapGetters("client", {
      team: "team"
    }),
    readyWaiting() {
      return this.gameClientState === this.gameStates.READY_WAITING;
    }
  },
  watch: {
    async gameClientState(newState, oldState) {
      if (this.gameClientState === this.gameStates.INTRODUCE_CATEGORY) {
        this.displayedComponent = "IntroduceCategory";
      } else if (
        this.gameClientState === this.gameStates.INTRODUCE_QUESTION ||
        this.gameClientState === this.gameStates.AWAITING_TEAM_ANSWERS
      ) {
        this.displayedComponent = "Question";
      } else if (
        this.gameClientState === this.gameStates.REVEAL_CATEGORY_SCORES
      ) {
        this.displayedComponent = "CategoryResults";
      } else if (this.gameClientState === this.gameStates.REVEAL_FINAL_SCORES) {
        this.displayedComponent = "FinalResults";
      } else {
        this.displayedComponent = "";
      }
    }
  },
  components: {
    CategoryResults,
    FinalResults,
    IntroduceCategory,
    Question
  }
};
</script>